<template>
  <el-select
    ref="user"
    v-model="selected"
    filterable
    collapse-tags
    v-loading="loading"
    :multiple="multiple"
    :disabled="disabled ? true : false"
    :placeholder="$t('selecione-uma-opcao')"
    @change="update()"
  >
    <el-option
      v-for="row of drivers"
      :key="row.id"
      :label="row.name"
      :value="row.id"
    ></el-option>
  </el-select>
</template>

<script>
import { UserService } from "@/services/users/user.services";
export default {
  name: "UserList",
  data: function () {
    return {
      drivers: [],
      selected: [""],
      loading: false,
    };
  },
  props: {
    customer: String,
    type: String,
    current: Array,
    disabled: Boolean,
    multiple: Boolean,
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.fetchRecords();
    },
    current: function (v) {
      const vm = this;
      vm.selected = vm.$props.current;
    },
  },
  methods: {
    fetchRecords() {
      const vm = this;
      vm.loading = true;
      if (vm.customer) {
        UserService.customer(vm.customer)
          .then((response) => {
            vm.drivers = response.sort((a, b) => a.name.localeCompare(b.name));
            setTimeout(() => {
              vm.selected = vm.$props.current;
            }, 500);
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => (vm.loading = false));
      } else {
        UserService.type(vm.type ? vm.type : "1")
          .then((response) => {
            vm.drivers = response.records.sort((a, b) =>
              a.name.localeCompare(b.name)
            );
            setTimeout(() => {
              vm.selected = vm.$props.current;
            }, 500);
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => (vm.loading = false));
      }
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
};
</script>
